const camelizeRE = /-(\w)/g
export const camelize = cached(str => {
  return str.replace(camelizeRE, (_, c) => (c ? c.toUpperCase() : ''))
})

export const capitalize = cached(str => {
  return str.charAt(0).toUpperCase() + str.slice(1)
})

const hyphenateRE = /\B([A-Z])/g
export const hyphenate = cached(str => {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
})

function cached(fn) {
  const cache = Object.create(null)
  return function(str) {
    const hit = cache[str]
    cache[str] = fn(str)
    return hit || cache[str]
  }
}
